import { isObject } from './object';

export default function (hexcolor) {
  if (typeof hexcolor !== 'string') return 'white';

  // eslint-disable-next-line no-param-reassign
  hexcolor = hexcolor.replace('#', '');

  if (hexcolor.length === 3) {
    // eslint-disable-next-line no-param-reassign
    hexcolor = hexcolor.split('')
      .map((hex) => hex + hex)
      .join('');
  }

  const r = parseInt(hexcolor.substr(0, 2), 16);
  const g = parseInt(hexcolor.substr(2, 2), 16);
  const b = parseInt(hexcolor.substr(4, 2), 16);
  const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
  return (yiq >= 128) ? 'black' : 'white';
}

export function getHexColor(color) {
  return isObject(color) ? color.hex : color;
}
